import React from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  IconButton,
  Paper,
  makeStyles
} from '@material-ui/core';
import { FilterList, Add } from '@material-ui/icons';
import { useTranslation } from '../hooks/useTranslation';

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundColor: 'var(--ikaro-text-white)',
    borderBottom: '1px solid var(--ikaro-gray-medium)',
    padding: theme.spacing(3),
  },
  headerContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  titleSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'left',
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: 'var(--ikaro-gray-darker)',
    marginBottom: theme.spacing(0.5),
  },
  subtitle: {
    color: 'var(--ikaro-gray-dark)',
    fontSize: '0.875rem',
  },
  actionsSection: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  filterButton: {
    borderColor: 'var(--ikaro-gray-medium)',
    color: 'var(--ikaro-gray-dark)',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'var(--ikaro-gray-light)',
    },
  },
  newJobButton: {
    backgroundColor: 'var(--ikaro-orange-primary)',
    color: 'var(--ikaro-text-white)',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'var(--ikaro-orange-hover)',
    },
  },
}));

const JobHeader = ({ 
  title, 
  subtitle, 
  showFilters, 
  onToggleFilters, 
  onNewJob,
  customActions = [],
  filterButtonLabel,
  newJobButtonLabel,
  showNewJobButton = true,
}) => {
  const classes = useStyles();
  const { t } = useTranslation('jobs');

  return (
    <Paper className={classes.header} elevation={0}>
      <Box className={classes.headerContent}>
        <Box className={classes.titleSection}>
          <Typography className={classes.title}>
            {title}
          </Typography>
          <Typography className={classes.subtitle}>
            {subtitle}
          </Typography>
        </Box>
        
        <Box className={classes.actionsSection}>
          {/* Ações customizadas */}
          {customActions.map((action, index) => {
            // Se não tem label, renderiza como IconButton
            if (!action.label) {
              return (
                <IconButton
                  key={index}
                  onClick={action.onClick}
                  disabled={action.disabled}
                  style={action.style}
                  className={action.className}
                >
                  {action.icon}
                </IconButton>
              );
            }
            
            // Se tem label, renderiza como Button normal
            return (
              <Button
                key={index}
                variant={action.variant || 'outlined'}
                color={action.color || 'default'}
                onClick={action.onClick}
                startIcon={action.icon}
                className={action.className}
                disabled={action.disabled}
              >
                {action.label}
              </Button>
            );
          })}
          
          {/* Botão de filtros */}
          <Button
            variant="outlined"
            className={classes.filterButton}
            startIcon={<FilterList />}
            onClick={onToggleFilters}
          >
            {filterButtonLabel || t('header.filters')}
          </Button>
          
          {/* Botão de nova tarefa */}
          {showNewJobButton && (
            <Button
              variant="contained"
              className={classes.newJobButton}
              startIcon={<Add />}
              onClick={onNewJob}
            >
              {newJobButtonLabel || t('header.newTask')}
            </Button>
          )}
        </Box>
      </Box>
    </Paper>
  );
};

export default JobHeader; 